import React from 'react';
import { PhoneIcon } from 'lucide-react';
export function SiteFooter() {
  return <footer className="w-full bg-white py-14" data-id="element-167" data-mp="3r8j6v639biqv">
      <div className="mx-auto w-full max-w-7xl px-5 lg:px-8" data-id="element-168" data-mp="3r8rk4z3akq2l">
        <div className="flex flex-col gap-8 border-b border-ash-200 pb-10 sm:flex-row sm:items-start sm:justify-between" data-id="element-169" data-mp="3mh1184qagtzk">
          <div data-id="element-170" data-mp="3hhohvtymm51q">
            <div className="flex items-baseline gap-2" data-id="element-171" data-mp="3hhwt7hf3p2at">
              <span className="font-display text-2xl tracking-tight text-ash-900" data-id="element-172" data-mp="3dhe2xrsuw4aq">Ultherapy</span>
              <span className="rounded bg-royal-600 px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.2em] text-white" data-id="element-173" data-mp="38h8gcq1g17zi">
                Prime
              </span>
            </div>
            <p className="mt-3 max-w-sm text-sm leading-relaxed text-ash-500" data-id="element-174" data-mp="2yjtzipblyh6o">
              Non-invasive ultrasound lifting and tightening, performed exclusively by trained, certified providers.
            </p>
          </div>
          <div className="flex flex-col gap-3 sm:items-end" data-id="element-175" data-mp="wta8dl70nz29">
            <a href="tel:18005550188" className="flex items-center gap-2 text-base font-semibold text-ash-900 transition-colors duration-150 ease-smooth hover:text-royal-700" data-id="element-176" data-mp="15qva55gw0thu">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-177" data-mp="vt7co7rwd7vz" />
              (800) 555-0188
            </a>
            <nav aria-label="Footer" className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-ash-500" data-id="element-178" data-mp="10qz5d40d8y18">
              <a href="#why" className="hover:text-royal-700" data-id="element-179" data-mp="1oh3a5epaj3tt">Why it works</a>
              <a href="#process" className="hover:text-royal-700" data-id="element-180" data-mp="1tg6d8tlpmzz5">What to expect</a>
              <a href="#guide" className="hover:text-royal-700" data-id="element-181" data-mp="1erjo606a6tuq">Free guide</a>
              <a href="#consult" className="hover:text-royal-700" data-id="element-182" data-mp="1eph03loovasn">Book a consult</a>
            </nav>
          </div>
        </div>
        <p className="mt-8 max-w-4xl text-xs leading-relaxed text-ash-400" data-id="element-183" data-mp="27gh59zyraklw">
          Individual results vary. Ultrasound skin lifting is indicated to improve the appearance of skin laxity;
          it is not a replacement for a surgical facelift. Consult a certified provider to determine whether you
          are a candidate. © {new Date().getFullYear()} All rights reserved.
        </p>
      </div>
    </footer>;
}